import { Component, Input, OnInit } from '@angular/core';
import  get from 'lodash-es/get';
import  take from 'lodash-es/take';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { Link } from '@finder/shared/interfaces/shared.interface';
import { Location } from '@finder/features/calendars/calendars.interface';
import { CalendarsService } from '@finder/features/calendars/services/calendars.service';
import { CommonModule } from '@angular/common';
import { DisclaimerComponent } from '@finder/shared/components/disclaimer/disclaimer.component';
import { AnchorComponent } from '@finder/shared/components/anchor/anchor.component';
import { FontIconComponent } from '@finder/shared/components/font-icon/font-icon.component';
import { ButtonComponent } from '@finder/shared/components/button/button.component';

@Component({
    selector: 'finder-park-section',
    templateUrl: './park-section.component.html',
    styleUrls: ['./park-section.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        DisclaimerComponent,
        AnchorComponent,
        FontIconComponent,
        ButtonComponent,
    ]
})
export class ParkSectionComponent implements OnInit {

    @Input() groups: any;
    @Input() permanentSchedule: any;
    @Input() labels: any;
    @Input() location: Location;
    @Input() parkHours = false;
    @Input() blockouts: Array<any>;
    @Input() title: string;
    @Input() type: string;
    @Input() icon: string;

    data: any;
    formattedDate: string;
    fullDateString: string;
    emptyHoursText: string;
    noBlockoutsText: string;
    limit: number;
    showLinks: boolean;
    viewAll: Link;
    hasBlockout: boolean; // tracks whether the blockout data is present and non empty
    isBlockoutEligible: boolean; // tracks whether brand/locale may show any blockout info
    permanentActivity: any;

    private destroy$ = new Subject<void>();

    constructor(
        private calendarsService: CalendarsService,
    ) { }

    ngOnInit() {
        // Magic Access links and blockout information should be hidden from ineligible locales,
        // which is determined in the API based on brand and locale
        this.isBlockoutEligible = this.location.isBlockoutEligible;

        // check if this section data contains blockout data and it may be shown
        this.hasBlockout = this.isBlockoutEligible && this.blockouts?.length > 0;

        // Get the empty hours message based on the section type and the "no blockouts" message.
        this.emptyHoursText = get(this.labels, `emptyHours.${this.type}`, this.labels.emptyHours.default);
        this.noBlockoutsText = get(this.labels, 'emptyHours.blockouts', this.labels.emptyHours.default);

        // Pull viewAll link.
        this.viewAll = get(this.groups, 'viewAll');
        this.limit = get(this.groups, 'limit', 4);
        this.title = this.title || get(this.groups, 'title');
        this.permanentActivity = get(this.groups, 'permanentActivity', false);

        // For Events, the schedules groups are under the "data" property.
        // Limit the number of Events that we show (if needed).
        this.data = get(this.groups, 'data') || this.groups;
        this.groups = this.limit ? take(this.data, this.limit) : this.data;
        this.showLinks = this.calendarsService.allowLinksOnPage();

        this.calendarsService.watchLocations()
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.fullDateString = this.calendarsService.fullDateString;
                this.formattedDate = this.calendarsService.formattedDate;
            });
    }

    onViewAll() {
        this.calendarsService.emitViewAll({
            events: this.data,
            date: this.formattedDate,
            title: this.title
        });
    }
}
